module.exports = __webpack_public_path__ + "ef0b92cd76f37e1241341651a14fd96e.svg";